// angular
//     .module("HeroPRO")
//     .factory("EDocumentsFactory", eDocumentsFactory);

/* @ngInject */
export default function eDocumentsFactory(HPConfig, $http) {
    return {
        getDocusignLink,
        emailDocusignLink,
        emailInstaller,
    };

    function getDocusignLink(fundingRequestId, documentType) {
        return $http.post(`${HPConfig.heroProApi}ESign/GeneratePropertyOwnerSignsDocsEnvelope`, {
            FundingRequestId: fundingRequestId,
            DocumentType: documentType,
        });
    }

    function emailDocusignLink(fundingRequestId, eDocumentRecipientId, documentType, email, ordinalInRole, loanid) {
        return $http.post(`${HPConfig.heroProApi}ESign/EmailPropertyOwnerSignDocsEnvelope`, {
            FundingRequestId: fundingRequestId,
            LoanId: loanid,
            EDocumentRecipientId: eDocumentRecipientId,
            DocumentType: documentType, // "FinancingDocs",
            Email: email,
            OwnerOrdinal: ordinalInRole,
        });
    }

    function emailInstaller(fundingRequestId, email) {
        return $http.post(`${HPConfig.heroProApi}ESign/EmailInstaller`, {
            FundingRequestId: fundingRequestId,
            InstallerEmail: email,
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/appDetail/walkthrough/startWork/EDocumentsFactory.js